import React, { useId } from "react";
import { SVG } from "../../interfaces/SVG.interface";

const Twitter: React.FC<SVG> = ({ className }) => {
  const titleId = useId();

  return (
    <svg
      width="27"
      height="23"
      viewBox="0 0 22.64 26"
      aria-labelledby={titleId}
      className={`transfrom fill-current ${className}`}
    >
      <title id={titleId}>Twitter logo</title>
      <path d="m22.64,26c-.15,0-.25,0-.35,0-2.04,0-4.08,0-6.12,0-.21,0-.33-.07-.44-.26-1.93-3.16-3.87-6.32-5.8-9.48-.06-.1-.12-.19-.2-.32-.49.64-.97,1.26-1.44,1.87-2.04,2.67-4.09,5.33-6.14,8-.06.07-.14.17-.21.17-.62.01-1.25,0-1.94,0,.09-.13.14-.21.19-.28,1.97-2.57,3.94-5.13,5.91-7.7.86-1.12,1.71-2.24,2.57-3.35.11-.15.12-.25.02-.42-2.08-3.39-4.16-6.78-6.24-10.18C1.67,2.79.89,1.52.12.25.08.19.06.13.02.02.15.02.24,0,.34,0,2.38,0,4.43,0,6.48,0c.2,0,.31.07.42.25,1.85,3.03,3.7,6.05,5.56,9.07.04.06.09.12.15.2.48-.62.94-1.22,1.39-1.82,1.9-2.48,3.81-4.96,5.71-7.45.14-.18.27-.26.49-.26.47.02.94,0,1.41,0,.08,0,.16.01.28.02-.06.1-.09.17-.13.23-2.3,3-4.6,5.99-6.9,8.99-.41.53-.81,1.07-1.22,1.59-.12.15-.1.24,0,.39,1.53,2.49,3.05,4.97,4.58,7.46,1.45,2.37,2.9,4.74,4.35,7.11.02.04.04.08.09.19Zm-2.76-1.64c-.1-.16-.15-.25-.21-.34-1.87-3-3.74-6-5.61-9C11.35,10.66,8.63,6.31,5.92,1.95c-.1-.16-.2-.23-.38-.22-.84,0-1.69,0-2.53,0-.07,0-.13.02-.23.03.05.09.08.15.11.21,2.71,4.35,5.42,8.7,8.13,13.05,1.89,3.03,3.78,6.07,5.67,9.1.11.18.22.26.42.25.36-.02.72,0,1.09,0,.53,0,1.06,0,1.67,0Z" />
    </svg>
  );
};

export default Twitter;
